module.exports = "/assets/data/98d1614c9af6fb7aa54c9a7a3087fe76-KA30.data.json";